import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LifeStyleQuestion, rangeData, dayMonthYearRangeDataModel } from 'src/app/pages/medical-underwriting/model';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';
import { MUConstants } from 'src/app/pages/medical-underwriting/medical-underwrting.constants';
import { SyncService } from '../../pages/medical-underwriting/services/sync.service';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { PersonalDetails } from 'src/app/model/ngrx/personal-details.model';
import { AppState } from 'src/app/store/state/app.state';

@Component({
  selector: 'app-multiple-inputbox',
  templateUrl: './multiple-inputbox.component.html',
  styleUrls: ['./multiple-inputbox.component.scss']
})
export class MultipleInputboxComponent implements OnInit {

  @Input() question: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  @Input() controlName: string;
  @Input() indexToAppend: number;
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  public daysRangeData: dayMonthYearRangeDataModel;
  public monthsRangeData: dayMonthYearRangeDataModel;
  public yearsRangeData: dayMonthYearRangeDataModel;
  selectedYears: string;
  selectedMonths: string;
  selectedDays: string;
  subscription: Subscription;
  public rangeValidationData: rangeData[];

  constructor(private fb: UntypedFormBuilder, private syncService: SyncService) {

  }

  ngOnInit() {
    this.subscription = this.syncService.getRangeValidationJson().subscribe((res) => {
      this.rangeValidationData = res;
      this.checkRange(this.rangeValidationData);
      this.selectedYears = "";
      this.selectedMonths = "";
      this.selectedDays = "";
      if (this.question.responseValueByUser) {
        let temp = this.question.responseValueByUser.split(MUConstants.dateFromatDelimiterToAPI);
        this.selectedDays = temp[0];
        this.selectedMonths = temp[1];
        this.selectedYears = temp[2];

        this.setValueForInputBox(this.question, this.formDateMonthYear());
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();    
  }

  setValueForInputBox(question: LifeStyleQuestion, dateMonthYear: string) {
    if (this.parent.controls[question.id]) {
      this.parent.controls[question.id].setValue(dateMonthYear);
    }
    else {
      this.parent.addControl(question.id, this.fb.control(null, question.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
      this.parent.controls[question.id].setValue(dateMonthYear);
    }
  }


  formDateMonthYear(): string {
    return ((this.selectedDays ? this.selectedDays : MUConstants.noDateToAPI) +
                                   MUConstants.dateFromatDelimiterToAPI +
                                   (this.selectedMonths ? this.selectedMonths : MUConstants.noMonthTOAPI) +
                                   MUConstants.dateFromatDelimiterToAPI +
                                   (this.selectedYears ? this.selectedYears : MUConstants.noYearToAPI));
  }


  setValueToFrom(event) {
    this.setValueForInputBox(this.question, this.formDateMonthYear());
  }

  initializeToolTipDateComp(questionObj: LifeStyleQuestion): Tooltip {
    return new Tooltip(questionObj.helpText, '', false);
  }

  checkRange(rangeValidationData: rangeData[]) {

    this.rangeValidationData.forEach(range => {
      if (this.question.responseRange) {
        // let temp =  this.question.responseRange.toString().split("=");
        // let newResponseFromJson = temp[1];
        if (range.valueKey === 'days') {
          this.daysRangeData = new dayMonthYearRangeDataModel();
          this.daysRangeData.valueMin = range.valueMin;
          this.daysRangeData.valueMax = range.valueMax;
        } else if (range.valueKey === 'months') {
          this.monthsRangeData = new dayMonthYearRangeDataModel();
          this.monthsRangeData.valueMin = range.valueMin;
          this.monthsRangeData.valueMax = range.valueMax;
        } else if (range.valueKey === 'years') {
          this.yearsRangeData = new dayMonthYearRangeDataModel();
          this.yearsRangeData.valueMin = range.valueMin;
          this.yearsRangeData.valueMax = range.valueMax;
        }
        //  //console.log('new response range', this.question.responseRange[0], this.question.responseRange[1]);

        // this.question.responseRange = newResponseFromJson === range.valueKey ? range.valueMax :  this.question.responseRange;
      }
    })
  }

  displayMobileTooltipReceiver(){
    this.onDisplayMobileTooltipEmitter.emit();
  }
}
